import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MobileSyncLogService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/mobileSyncLogs')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-rotate';
    }

    /**
     * Gets sync logs for a session.
     */
    getBySession(sessionId: number): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/by-session/${sessionId}`);
    }

    /**
     * Gets recent failures.
     */
    getRecentFailures(days: number = 7): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/recent-failures?days=${days}`);
    }

    /**
     * Gets syncs with conflicts.
     */
    getSyncsWithConflicts(days: number = 7): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/with-conflicts?days=${days}`);
    }

    /**
     * Gets statistics for a session.
     */
    getStatistics(sessionId: number): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/statistics/${sessionId}`);
    }
}
